export enum MeteoHomeTabs {
  ThirtySixHours = '36-heures',
  FifteenDays = '15-jours',
  TwentyHeightDays = '28-jours',
}
